import Rest from '../../Rest'

export default class RequestFormIncidentService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/request_form_incident'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  getFormData(filters: any) {
    return this.get('', filters).then(data => {
      return data
    })
  }

  saveFormData(data: any) {
    return this.post('', data, { headers: {
      'Content-Type': 'multipart/form-data;'
    }}).then(data => {
      return data
    })
  }

  updateFormData(id: string, data: any) {
    return this.post(`${id}`, data, { headers: {
      'Content-Type': 'multipart/form-data;'
    }}).then(data => {
      return data
    })
  }

  updateForm(id: number, data: any) {
    return this.put(`${id}`, data ).then(data => {
      return data
    })
  }

  uploadFile(id: string, data: any) {
    return this.post(`${id}/attachment`, data, { headers: {
      'Content-Type': 'multipart/form-data;'
    }}).then(data => {
      return data
    })
  }

  deleteFile(id: string, mediaId: string) {
    return this.delete(`${id}/attachment/${mediaId}`).then(data => {
      return data
    })
  }

  getListLegalEntity(paramEncrypt: String | null, legalEntityId: String | null) {
    return this.get(`legal_entitys`, {
        param_encrypt: paramEncrypt ?? '',
        legal_entity_id: legalEntityId ?? ''
    }).then(data => {
      return data
    })
  }

  getListIncidentCoupAttemptType() {
    return this.get('incident_coup_attempt_types').then(data => {
      return data
    })
  }

  getListIncidentType() {
    return this.get('incident_type').then(data => {
      return data
    })
  }

  getListIncidentAcidProperty() {
    return this.get('incident_acid_property').then(data => {
      return data
    })
  }

  getListIncidentLeakedContent() {
    return this.get('incident_leaked_content').then(data => {
      return data
    })
  }

  getListIncidentGroup() {
    return this.get('incident_groups').then(data => {
      return data
    })
  }
}
